module.exports = __webpack_public_path__ + "img/index1.3b435c69.png";